module.exports = __webpack_public_path__ + "img/04-illu-matome2021.c57cf8fc.png";